import {createAction, handleActions} from 'redux-actions';

const FETCH = '@nezzokontikifrontend/Person/FETCH';
const FETCH_FAILED = '@nezzokontikifrontend/Person/FETCH_FAILED';
const SET = '@nezzokontikifrontend/Person/SET';

export const actionTypes = {
	FETCH,
	FETCH_FAILED,
	SET
};

const fetch = createAction(FETCH, uid => uid);

const fetchFailed = createAction(FETCH_FAILED);

const set = createAction(SET, person => person);

export const actions = {
	fetch,
	fetchFailed,
	set
};

const defaultState = {
	person: null,
};

export const reducer = handleActions({
	[FETCH]: (state) => {
		return {...state};
	},
	[FETCH_FAILED]: (state) => {
		return {...state, person: null};
	},
	[SET]: (state, action) => {
		return {...state, person: action.payload.data};
	},
}, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/person.js